<template>
  <div>
    <center-header :selected-menu-item="7" />
    <cdr-flag-detail-content
      api-url="/api/internal/center-admin/cdr/flags/"
      back-route="/center/cdr"
    />
  </div>
</template>

<script>
import CenterHeader from "../CenterHeader.vue";
import CdrFlagDetailContent from "../../ClinicalDataRemoval/CdrFlagDetailContent.vue";

export default {
  components: { CenterHeader, CdrFlagDetailContent },
};
</script>
